import React from 'react';
import { arrayOf, bool, func, node, string, object } from 'prop-types';
import { edocketObjectType } from './edocketObjectType';
import TimeSummary from './partials/TimeSummary';
import Section from './partials/Section';
import { getDate, isDateEmpty } from '../../utils/dates';
import { findObjectInArray } from '../../../helpers/generalHelper';

export default class Details extends React.Component {
    constructor(props) {
        super(props);

        this.equipmentCostcodeInputChanged = this.equipmentCostcodeInputChanged.bind(this);
    }

    getTotalWaitTime() {
        const totalWaitTime = new Date(
            1900,
            0,
            0,
            0,
            this.props.edocket.Summary.WaitingTime
        );

        const totalWaitTimeMinutes = this.getTotalWaitTimeItems();

        totalWaitTime.setMinutes(totalWaitTime.getMinutes() + totalWaitTimeMinutes);

        return totalWaitTime;
    }

    getTotalWaitTimeItems() {
        let totalMinute = 0;
        if (this.props.edocket.WaitingTimeItem !== null) {
            if (this.props.edocket.WaitingTimeItem.WaitingTimeItems.length > 0) {
                this.props.edocket.WaitingTimeItem.WaitingTimeItems
                    .forEach(item => {
                        totalMinute += item.WaitingTimeMinutes;
                    });
            }
        }

        return totalMinute;
    }

    timeEntries() {
        const totalWaitTime = this.getTotalWaitTime();
        const totalWaitTimeItems = this.getTotalWaitTimeItems();

        const startTime = getDate(this.props.edocket.Summary.TimeStart);
        const finishTime = getDate(this.props.edocket.Summary.TimeFinish);
        const totalShiftTime = getDate(this.props.edocket.Summary.TimeWorked);

        if (startTime && finishTime && totalShiftTime) {
            const timeDetails = [
                {
                    label: 'Start time',
                    value: startTime
                },
                {
                    label: 'Finish time',
                    value: finishTime
                },
                {
                    label: 'Break time',
                    value: new Date(this.props.edocket.Summary.TimeBreak)
                },
                {
                    label: 'Total shift time',
                    value: totalShiftTime
                }
            ];

            if (totalWaitTimeItems > 0) {
                timeDetails.push({
                    label: 'Incurred waiting time',
                    value: (!isDateEmpty(totalWaitTime)) ? totalWaitTime : null,
                    modifier: 'error'
                });
            }

            return timeDetails;
        }

        return [];
    }

    queryReasonString() {
        const queryInfo = this.props.edocket.DocketQueryInfo;
        switch (true) {
            case queryInfo.QueryReasonHours:
                return 'Incorrect Hours';
            case queryInfo.QueryReasonLoads:
                return 'Incorrect Loads';
            case queryInfo.QueryReasonPONumber:
                return 'Incorrect P/O#';
            case queryInfo.QueryReasonWaitingTime:
                return 'Waiting Time';
            case queryInfo.QueryReasonOther:
                return 'Other Reason';
            default:
                return '';
        }
    }

    hasEquipmentItems() {
        return this.props.edocket.EquipmentItems.length > 0;
    }

    hasTipItems() {
        return this.props.edocket.TipItems.length > 0;
    }

    hasLoadItems() {
        const LoadItems = this.props.edocket.LoadItems ? this.props.edocket.LoadItems : [];
        return LoadItems.length > 0;
    }

    hasTollItems() {
        const TollItems = this.props.edocket.TollItems ? this.props.edocket.TollItems : [];
        return TollItems.length > 0;
    }

    hasWaitingTimeItems() {
        return this.props.edocket.WaitingTimeItem !== null;
    }

    hasAdditionalCharges() {
        return !!this.props.edocket.AdditionalCharges;
    }

    hasNoteComment() {
        return !!this.props.edocket.Summary.NoteComment;
    }

    hasQueryInfo() {
        switch (this.props.edocket.Summary.DraftDocketStatus) {
            case 'Client Approved':
            case 'Approved':
            case 'Client Queried':
            case 'Queried':
            case 'Contractor Submitted':
            case 'Submitted':
                return true;
            default:
                return false;
        }
    }

    collectCarting() {
        let carting = this.props.edocket.LoadItems.reduce(
            (previous, current) => previous + current.LoadCount,
            0
        );
        carting = Math.round(carting * 100) / 100;
        const item = this.props.edocket.LoadItems[0];

        return `${carting} ${item.CartingMaterialUOMText} of ${item.CartingMaterialName}`;
    }

    queryInfoHeading() {
        const { dataApproveMessage, dataApproveSuccess, dataQueryMessage, dataQuerySuccess } = this.props;

        switch (this.props.edocket.Summary.DraftDocketStatus) {
            case 'Client Approved':
            case 'Approved':
                return 'Approved';
            case 'Client Queried':
            case 'Queried':
                return 'Queried';
            default:
                if (dataApproveMessage && !dataApproveSuccess) {
                    return 'Approve Action Failed';
                } else if (dataApproveSuccess === true) {
                    return 'Approved';
                } else if (dataQueryMessage && !dataQuerySuccess) {
                    return 'Query Action Failed';
                } else if (dataQuerySuccess === true) {
                    return 'Queried';
                }
                return 'Action required';
        }
    }

    queryInfoContents() {
        const { dataApproveMessage, dataApproveSuccess, dataQueryMessage, dataQuerySuccess, actionDisabledMessage } = this.props;

        if ((this.props.edocket.Summary.DraftDocketStatus === 'Client Queried' || this.props.edocket.Summary.DraftDocketStatus === 'Queried') && this.props.edocket.DocketQueryInfo) {
            return (
                <table className="edocket-tabs-data-table">
                    <thead>
                        <tr>
                            <th>By</th>
                            <th>Reason</th>
                            <th>Notes</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{this.props.edocket.DocketQueryInfo.QueriedBy}</td>
                            <td>{this.queryReasonString()}</td>
                            <td>{this.props.edocket.DocketQueryInfo.QueryNotes}</td>
                        </tr>
                    </tbody>
                </table>
            );
        }
        if ((this.props.edocket.Summary.DraftDocketStatus === 'Client Approved')
                || (this.props.edocket.Summary.DraftDocketStatus === 'Approved')) {
            return (
                <p>
                    eDocket {this.props.edocket.Summary.eDocketNumber} has now been approved
                    and has been uploaded to our system for processing
                </p>
            );
        }
        if (dataApproveMessage && dataApproveSuccess) {
            return (
                <p>
                    {dataApproveMessage}
                </p>
            );
        }
        if (dataQueryMessage && dataQuerySuccess) {
            return (
                <p>
                    {dataQueryMessage}
                </p>
            );
        }
        if (this.props.shouldShowQueryAndApprove()) {
            return (
                <React.Fragment>
                    {!actionDisabledMessage && (
                        <React.Fragment>
                            <button className="btn-approve" onClick={this.props.sendApproval}>Approve</button>
                            &ensp;
                            <button className="btn-query" onClick={() => this.props.toggleQueryForm(false)}>
                                Query
                            </button>
                        </React.Fragment>
                    )}
                    {actionDisabledMessage && (
                        <p className="action-cost-code-info">{actionDisabledMessage}</p>
                    )}
                    <p className="action-cost-code-info">You can add a Cost Code once the Docket has been actioned.</p>
                </React.Fragment>
            );
        }

        return null;
    }

    formatDate(timestamp) {
        const date = new Date(timestamp);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const timeOption = { timeStyle: 'short' };
        const formattedDate = `${date.toLocaleString('en-au', options)} ${date.toLocaleString('en-au', timeOption)}`;
        return formattedDate;
    }

    waitingTimeContents() {
        const waitingTimeCount = this.props.edocket.WaitingTimeItem.WaitingTimeItems.length;
        const {
            primaryCostCode, enableCostCodeEdit,
            waitingTimeCostCodes, waitingTimeCostCodeEditing,
            waitingTimeActionButtonHandler, waitingTimeCancelButtonHandler
        } = this.props;

        if (this.props.edocket.WaitingTimeItem.Version > 1) {
            return (
                <Section
                    caption="Waiting times"
                    editable={enableCostCodeEdit}
                    isEditing={waitingTimeCostCodeEditing}
                    actionButtonHandler={waitingTimeActionButtonHandler}
                    cancelButtonHandler={waitingTimeCancelButtonHandler}
                    closed={
                        <table className="edocket-tabs-data-table">
                            <tbody>
                                <tr>
                                    <th>
                                        <strong>
                                            {waitingTimeCount} Instance{waitingTimeCount === 1 ? '' : 's'}
                                        </strong>
                                    </th>
                                    <th>Loading from</th>
                                    <th>Total Minutes</th>
                                </tr>
                                {this.props.edocket.WaitingTimeItem.WaitingTimeItemsGrouped.map((item, index) => (
                                    /* eslint-disable-next-line react/no-array-index-key */
                                    <tr key={`edocket-tabs-data-table-waiting-time-summary-${index}`}>
                                        <td>{item.Summary}</td>
                                        <td>{item.LoadingFrom}</td>
                                        <td>{item.TotalWaitingTimeMinutes}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    }
                    opened={
                        <div className="edocket-tabs-data-table">
                            {this.props.edocket.WaitingTimeItem.WaitingTimeItems.map((item, index) => {
                                const waitingTimeCostcodeObj = findObjectInArray(waitingTimeCostCodes, 'LoadItemID', item.WaitingTimeID);
                                let costcodeValue = '';
                                if (waitingTimeCostcodeObj && waitingTimeCostcodeObj.CostCode) {
                                    costcodeValue = waitingTimeCostcodeObj.CostCode;
                                }

                                return (
                                    /* eslint-disable-next-line react/no-array-index-key */
                                    <div key={`edocket-tabs-data-table-waiting-time-details-${index}`}>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <th id="load">load</th>
                                                    <th id="from">loading from</th>
                                                    {item.WaitingTimeLoadingMinutes && <th id="time" className="right">Agreed Loading time</th>}
                                                    <th id="minutes" className="right">Incurred Waiting Time</th>
                                                </tr>
                                                <tr >
                                                    <td headers="load">#{item.WaitingTimeLoadNo}</td>
                                                    <td headers="from">{item.WaitingTimeLoadingFrom}</td>
                                                    {item.WaitingTimeLoadingMinutes && <td headers="time" className="right">{item.WaitingTimeLoadingMinutes}</td>}
                                                    <td headers="minutes" className="right">{item.WaitingTimeMinutes}</td>
                                                </tr>
                                                <tr>
                                                    <td />
                                                    {item.WaitingTimeStart && <th id="arrived">Arrived for load</th>}
                                                    {item.WaitingTimeFinish && <th id="left" colSpan="2">Left Site</th>}
                                                </tr>
                                                <tr >
                                                    <td />
                                                    {item.WaitingTimeStart && <td headers="arrived" >{this.formatDate(item.WaitingTimeStart)}</td>}
                                                    {item.WaitingTimeStart && <td headers="left" colSpan="2">{this.formatDate(item.WaitingTimeFinish)}</td>}
                                                </tr>
                                                {/* <tr>
                                                    <th id="load">load</th>
                                                    <th id="from">loading from</th>
                                                    {item.WaitingTimeStart && <th id="arrived" className="x-small-column right">Arrived</th>}
                                                    {item.WaitingTimeFinish && <th id="left" className="x-small-column right">Left Site</th>}
                                                    <th id="minutes" className="x-small-column right">Minutes</th>
                                                </tr>
                                                <tr >
                                                    <td headers="load">#{item.WaitingTimeLoadNo}</td>
                                                    <td headers="from">{item.WaitingTimeLoadingFrom}</td>
                                                    {item.WaitingTimeStart && <td headers="arrived" className="right">{item.WaitingTimeStart}</td>}
                                                    {item.WaitingTimeStart && <td headers="left" className="right">{item.WaitingTimeFinish}</td>}
                                                    <td headers="minutes" className="right">{item.WaitingTimeMinutes}</td>
                                                </tr> */}
                                                <tr>
                                                    <td />
                                                    <th id="reason" colSpan="2">Reason/Comments</th>
                                                    <th>Cost Code</th>
                                                </tr>
                                                <tr>
                                                    <td />
                                                    <td header="reason" colSpan="2">{item.WaitingTimeComment}</td>
                                                    {waitingTimeCostCodeEditing &&
                                                        <td>
                                                            <input
                                                                className="detail-costcode-input"
                                                                type="text"
                                                                maxLength="20"
                                                                placeholder="Enter Cost Code"
                                                                value={costcodeValue}
                                                                onChange={event => this.waitingTimeCostcodeInputChanged(
                                                                    event,
                                                                    item.WaitingTimeID
                                                                )}
                                                            />
                                                        </td>
                                                    }
                                                    {!waitingTimeCostCodeEditing &&
                                                        <td>{item.WaitingTimeCostCode ?
                                                            item.WaitingTimeCostCode :
                                                            primaryCostCode}
                                                        </td>
                                                    }
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                );
                            })}
                        </div>
                    }
                />
            );
        }

        return (
            <Section caption="Waiting times">
                <table className="edocket-tabs-data-table">
                    <thead>
                        <tr>
                            <th>Total minutes</th>
                            <th>Started at</th>
                            <th>Reason/Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.edocket.WaitingTimeItem.WaitingTimeItems.map((item, index) => (
                            /* eslint-disable-next-line react/no-array-index-key */
                            <tr key={`edocket-tabs-data-table-waiting-times-${index}`}>
                                <td>{item.WaitingTimeMinutes}</td>
                                <td>{item.WaitingTimeStartingAt}</td>
                                <td>{item.WaitingTimeComment}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Section>
        );
    }

    equipmentCostcodeInputChanged(event, id) {
        const { equipmentCostCodeChangeHandler } = this.props;
        equipmentCostCodeChangeHandler(event.target.value, id);
    }

    loadCostcodeInputChanged(event, id) {
        const { loadCostCodeChangeHandler } = this.props;
        loadCostCodeChangeHandler(event.target.value, id);
    }

    waitingTimeCostcodeInputChanged(event, id) {
        const { waitingTimeCostCodeChangeHandler } = this.props;
        waitingTimeCostCodeChangeHandler(event.target.value, id);
    }

    tollCostcodeInputChanged(event, id) {
        const { tollCostCodeChangeHandler } = this.props;
        tollCostCodeChangeHandler(event.target.value, id);
    }

    hasLocation(item) {
        return !!item.Location;
    }

    loadItemsData(isClosed) {
        const {
            edocket, primaryCostCode,
            loadCostCodes, loadCostCodeEditing
        } = this.props;

        const { Summary, LoadItemsGrouped, LoadItems } = edocket;
        let totalLoad;
        const loadsCount = this.props.edocket.LoadItems.length;
        if (Summary.TotalLoads) {
            totalLoad = Summary.TotalLoads;
        }

        if (isClosed) {
            return (
                <table className="edocket-tabs-data-table loads-table">
                    <tbody>
                        <tr>
                            <th className="x-small-column secondary-heading">{ totalLoad ? totalLoad : `${loadsCount} Load${loadsCount > 1 ? 's' : ''}` }</th>
                            <th>
                                    Carting
                            </th>
                            {this.hasLocation(LoadItemsGrouped[0]) ?
                                <React.Fragment>
                                    <th>Location</th>
                                </React.Fragment> :
                                <React.Fragment>
                                    <th>Loading from</th>
                                    <th>Disposing at</th>
                                </React.Fragment>
                            }
                        </tr>
                        {this.hasLocation(LoadItemsGrouped[0]) ?
                            <React.Fragment>
                                {LoadItemsGrouped.map((item, index) => (
                                /* eslint-disable-next-line react/no-array-index-key */
                                    <tr key={`edocket-tabs-data-table$-items-summary-${index}`}>
                                        <td />
                                        <td>{item.Summary}</td>
                                        <td>{item.Location}</td>
                                    </tr>
                                ))}
                            </React.Fragment> :
                            <React.Fragment>
                                {LoadItemsGrouped.map((item, index) => (
                                    /* eslint-disable-next-line react/no-array-index-key */
                                    <tr key={index}>
                                        <td />
                                        <td>{item.Summary}</td>
                                        <td>{item.LoadingFrom}</td>
                                        <td>{item.DisposalAt}</td>
                                    </tr>
                                ))}
                            </React.Fragment>
                        }
                    </tbody>
                </table>
            );
        }

        return (
            <table className="edocket-tabs-data-table">
                <tbody>
                    {LoadItems.map((item, index) => {
                        const loadCostcodeObj = findObjectInArray(loadCostCodes, 'LoadItemID', item.LoadID);
                        let costcodeValue = '';
                        if (loadCostcodeObj && loadCostcodeObj.CostCode) {
                            costcodeValue = loadCostcodeObj.CostCode;
                        }
                        return this.hasLocation(item) ?
                            ((/* eslint-disable-next-line react/no-array-index-key */
                                <React.Fragment key={`edocket-tabs-data-table-details-${item.LoadNo}${index}`}>
                                    <tr>
                                        <th className="x-small-column">Item</th>
                                        <th>Carting</th>
                                        <th>Location</th>
                                    </tr>
                                    <tr>
                                        <td>{item.LoadNo}</td>
                                        <td>{item.TipDisplayLine3}</td>
                                        <td>{item.Location}</td>
                                    </tr>
                                    <tr>
                                        <th />
                                        <th>Cost Code</th>
                                        {
                                            item.TipDisplayLine4.length > 0 &&
                                            <th>EPA Certificate</th>
                                        }
                                    </tr>
                                    <tr>
                                        <td />
                                        {loadCostCodeEditing &&
                                        <td>
                                            <input
                                                className="detail-costcode-input"
                                                type="text"
                                                maxLength="20"
                                                placeholder="Enter Cost Code"
                                                value={costcodeValue}
                                                onChange={event => this.loadCostcodeInputChanged(
                                                    event,
                                                    item.LoadID
                                                )}
                                            />
                                        </td>
                                        }
                                        {!loadCostCodeEditing &&
                                        <td>{item.CostCode ? item.CostCode : primaryCostCode}</td>
                                        }
                                        <td>{item.TipDisplayLine4.length > 0 ? item.TipDisplayLine4 : ''}</td>
                                    </tr>
                                </React.Fragment>
                            )) : (
                                <React.Fragment>
                                    {/* eslint-disable-next-line react/no-array-index-key */}
                                    <tr key={`edocket-tabs-data-table-details-${item.LoadNo}${index}`}>
                                        <th className="x-small-column">Load</th>
                                        <th>Loading from</th>
                                        <th>Disposing at</th>
                                    </tr>
                                    <tr>
                                        <td>{item.LoadNo}</td>
                                        <td>{item.TipDisplayLine1}</td>
                                        <td>{item.TipDisplayLine2}</td>
                                    </tr>
                                    <tr>
                                        <th />
                                        <th>Cost Code</th>
                                        <th>Carting</th>
                                    </tr>
                                    <tr>
                                        <td />
                                        {loadCostCodeEditing &&
                                        <td>
                                            <input
                                                className="detail-costcode-input"
                                                type="text"
                                                maxLength="20"
                                                placeholder="Enter Cost Code"
                                                value={costcodeValue}
                                                onChange={event => this.loadCostcodeInputChanged(
                                                    event,
                                                    item.LoadID
                                                )}
                                            />
                                        </td>
                                        }
                                        {!loadCostCodeEditing &&
                                        <td>{item.CostCode ? item.CostCode : primaryCostCode}</td>
                                        }
                                        <td>{item.TipDisplayLine3}</td>
                                    </tr>
                                    {item.TipDisplayLine4.length > 0 && [
                                        <tr>
                                            <th />
                                            <th>EPA Certificate</th>
                                            <th />
                                        </tr>,
                                        <tr>
                                            <td />
                                            <td>{item.TipDisplayLine4}</td>
                                            <td />
                                        </tr>
                                    ]}
                                </React.Fragment>
                            );
                    })}
                </tbody>
            </table>
        );
    }

    render() {
        const timeEntries = this.timeEntries();
        const {
            dataApproveMessage,
            dataApproveSuccess,
            dataQueryMessage,
            dataQuerySuccess,
            shouldDisplayBottomCostcode, primaryCostCode, enableCostCodeEdit,
            equipmentCostCodes, equipmentCostCodeEditing, equipmentActionButtonHandler, equipmentCancelButtonHandler,
            loadCostCodeEditing, loadActionButtonHandler, loadCancelButtonHandler,
            tollCostCodes, tollCostCodeEditing, tollActionButtonHandler, tollCancelButtonHandler
        } = this.props;
        const actionError = (dataApproveMessage && !dataApproveSuccess) || (dataQueryMessage && !dataQuerySuccess);
        const actionErrorMessage = dataApproveMessage || dataQueryMessage;

        if (
            timeEntries.length === 0 && !this.hasEquipmentItems() && !this.hasLoadItems() && !this.hasTollItems()
            && !this.hasWaitingTimeItems() && !this.hasAdditionalCharges() && !this.hasNoteComment() && !this.hasQueryInfo()
        ) {
            return <div className="edocket-tab-details">Nothing to show</div>;
        }

        return (
            <div className="edocket-tab-details">
                <TimeSummary entries={timeEntries} />

                {this.hasEquipmentItems() && (
                    <Section
                        caption="Equipment"
                        editable={enableCostCodeEdit}
                        isEditing={equipmentCostCodeEditing}
                        actionButtonHandler={equipmentActionButtonHandler}
                        cancelButtonHandler={equipmentCancelButtonHandler}
                    >
                        <table className="edocket-tabs-data-table">
                            <thead>
                                <tr>
                                    <th>Equipment</th>
                                    <th>Quantity</th>
                                    <th>Cost Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.edocket.EquipmentItems.map((item, index) => {
                                    const equipmentCostcodeObj = findObjectInArray(equipmentCostCodes, 'EquipmentItemID', item.DraftDocketEquipmentItem_ID);
                                    let costcodeValue = '';
                                    if (equipmentCostcodeObj && equipmentCostcodeObj.CostCode) {
                                        costcodeValue = equipmentCostcodeObj.CostCode;
                                    }

                                    return (
                                        /* eslint-disable-next-line react/no-array-index-key */
                                        <tr key={`edocket-tabs-data-table-equipment-items-${index}`}>
                                            <td>{item.EquipmentType_Name}</td>
                                            <td>{item.Quantity} {item.UnitOfMeasureText}</td>
                                            {equipmentCostCodeEditing &&
                                                <td>
                                                    <input
                                                        className="detail-costcode-input"
                                                        type="text"
                                                        maxLength="20"
                                                        placeholder="Enter Cost Code"
                                                        value={costcodeValue}
                                                        onChange={event => this.equipmentCostcodeInputChanged(
                                                            event,
                                                            item.DraftDocketEquipmentItem_ID
                                                        )}
                                                    />
                                                </td>
                                            }
                                            {!equipmentCostCodeEditing &&
                                                <td>{item.CostCode ? item.CostCode : primaryCostCode}</td>
                                            }
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Section>
                )}

                {this.hasTipItems() && (
                    <Section caption="Tips">
                        <table className="edocket-tabs-data-table">
                            <thead>
                                <tr>
                                    <th>Tips / Loads x Material</th>
                                    <th className="small-column">Volume</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.edocket.TipItems.map((item, index) => (
                                    /* eslint-disable-next-line react/no-array-index-key */
                                    <tr key={`edocket-tabs-data-table-tip-items-${index}`}>
                                        <td>{item.Tip_Name}
                                            <span>{item.TipMaterialUnits_ID} {item.TipMaterialUOMText}</span>
                                        </td>
                                        <td>
                                            <span>{item.TipMaterialUnits_ID} {item.TipMaterialUOMText}</span>
                                            {item.TipEPALoads ? `${item.TipEPALoads} EPA Load` : null}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Section>
                )}

                {this.hasLoadItems() && (
                    <Section
                        caption="Loads"
                        editable={enableCostCodeEdit}
                        isEditing={loadCostCodeEditing}
                        actionButtonHandler={loadActionButtonHandler}
                        cancelButtonHandler={loadCancelButtonHandler}
                        closed={
                            this.loadItemsData(true)
                        }
                        opened={
                            this.loadItemsData(false)
                        }
                    />
                )}

                {this.hasTollItems() && (
                    <Section
                        caption="Tolls"
                        editable={enableCostCodeEdit}
                        isEditing={tollCostCodeEditing}
                        actionButtonHandler={tollActionButtonHandler}
                        cancelButtonHandler={tollCancelButtonHandler}
                    >
                        <table className="edocket-tabs-data-table">
                            <thead>
                                <tr>
                                    <th>Trips</th>
                                    <th>Entry</th>
                                    <th>Exit</th>
                                    <th>Cost Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.edocket.TollItems.map((item, index) => {
                                    const tollCostcodeObj = findObjectInArray(tollCostCodes, 'TollItemID', item.DraftDocketTollItem_ID);
                                    let costcodeValue = '';
                                    if (tollCostcodeObj && tollCostcodeObj.CostCode) {
                                        costcodeValue = tollCostcodeObj.CostCode;
                                    }

                                    return (
                                        /* eslint-disable-next-line react/no-array-index-key */
                                        <tr key={`edocket-tabs-data-table-toll-items-${index}`}>
                                            <td>{item.TripCount}</td>
                                            <td>{item.EntryTollName}</td>
                                            <td>{item.ExitTollName}</td>
                                            {tollCostCodeEditing &&
                                                <td>
                                                    <input
                                                        className="detail-costcode-input"
                                                        type="text"
                                                        maxLength="20"
                                                        placeholder="Enter Cost Code"
                                                        value={costcodeValue}
                                                        onChange={event =>
                                                            this.tollCostcodeInputChanged(
                                                                event,
                                                                item.DraftDocketTollItem_ID
                                                            )}
                                                    />
                                                </td>
                                            }
                                            {!tollCostCodeEditing &&
                                                <td>{item.CostCode ? item.CostCode : primaryCostCode}</td>
                                            }
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Section>
                )}

                {this.hasWaitingTimeItems() && this.waitingTimeContents()}

                {this.hasAdditionalCharges() && (
                    <Section caption="Additional Charges">
                        <p>{this.props.edocket.AdditionalCharges}</p>
                    </Section>
                )}

                {this.hasNoteComment() && (
                    <Section caption="Comments">
                        <p>{this.props.edocket.Summary.NoteComment}</p>
                    </Section>
                )}

                {this.hasQueryInfo() && !shouldDisplayBottomCostcode && (
                    <Section
                        caption={this.queryInfoHeading()}
                    >
                        {
                            !actionError &&
                            this.queryInfoContents()
                        }
                        {
                            actionError &&
                            <span className="error-text">{actionErrorMessage}</span>
                        }
                    </Section>
                )}

                {this.hasQueryInfo() && shouldDisplayBottomCostcode && (
                    <div className="details-two-column">
                        <Section
                            caption={this.queryInfoHeading()}
                            className="section-half-width"
                        >
                            {
                                !actionError &&
                                this.queryInfoContents()
                            }
                            {
                                actionError &&
                                <span className="error-text">{actionErrorMessage}</span>
                            }
                        </Section>
                        <Section
                            caption="Need to add a cost code?"
                            className="section-cost-code section-half-width"
                        >
                            <p className="section-cost-code-desc">
                                Click the button below to add your costcode.<br />
                                The code will be saved against this docket for your reporting purposes
                            </p>
                            <button className="btn-costcode" onClick={this.props.bottomCostCodeButtonHandler}>Add a Cost Code</button>
                        </Section>
                    </div>
                )}
                {this.props.queryForm && (
                    <Section caption="Query form">
                        {this.props.queryForm}
                    </Section>
                )}
            </div>
        );
    }
}

Details.propTypes = {
    edocket: edocketObjectType,
    toggleQueryForm: func.isRequired,
    sendApproval: func.isRequired,
    shouldShowQueryAndApprove: func.isRequired,
    queryForm: node,
    dataApproveMessage: string,
    dataApproveSuccess: bool,
    dataQueryMessage: string,
    dataQuerySuccess: bool,
    primaryCostCode: string,
    shouldDisplayBottomCostcode: bool,
    enableCostCodeEdit: bool,
    bottomCostCodeButtonHandler: func,
    equipmentCostCodes: arrayOf(object),
    equipmentCostCodeEditing: bool,
    equipmentActionButtonHandler: func,
    equipmentCancelButtonHandler: func,
    equipmentCostCodeChangeHandler: func,
    loadCostCodes: arrayOf(object),
    loadCostCodeEditing: bool,
    loadActionButtonHandler: func,
    loadCancelButtonHandler: func,
    loadCostCodeChangeHandler: func,
    waitingTimeCostCodes: arrayOf(object),
    waitingTimeCostCodeEditing: bool,
    waitingTimeActionButtonHandler: func,
    waitingTimeCancelButtonHandler: func,
    waitingTimeCostCodeChangeHandler: func,
    tollCostCodes: arrayOf(object),
    tollCostCodeEditing: bool,
    tollActionButtonHandler: func,
    tollCancelButtonHandler: func,
    tollCostCodeChangeHandler: func,
    actionDisabledMessage: string
};

/*
equipmentCostCodes={equipmentCostCodes}
equipmentCostCodeEditing={equipmentCostCodeEditing}
equipmentActionButtonHandler={this.equipmentActionButtonHandler}
equipmentCancelButtonHandler={this.equipmentCancelButtonHandler}
equipmentCostCodeChangeHandler
*/

Details.defaultProps = {
    queryForm: '',
    edocket: null,
    dataApproveMessage: '',
    dataApproveSuccess: undefined,
    dataQueryMessage: '',
    dataQuerySuccess: undefined,
    shouldDisplayBottomCostcode: false,
    enableCostCodeEdit: false,
    primaryCostCode: '',
    bottomCostCodeButtonHandler: null,
    equipmentCostCodes: [],
    equipmentCostCodeEditing: false,
    equipmentActionButtonHandler: null,
    equipmentCancelButtonHandler: null,
    equipmentCostCodeChangeHandler: null,
    loadCostCodes: [],
    loadCostCodeEditing: false,
    loadActionButtonHandler: null,
    loadCancelButtonHandler: null,
    loadCostCodeChangeHandler: null,
    waitingTimeCostCodes: [],
    waitingTimeCostCodeEditing: false,
    waitingTimeActionButtonHandler: null,
    waitingTimeCancelButtonHandler: null,
    waitingTimeCostCodeChangeHandler: null,
    tollCostCodes: [],
    tollCostCodeEditing: false,
    tollActionButtonHandler: null,
    tollCancelButtonHandler: null,
    tollCostCodeChangeHandler: null,
    actionDisabledMessage: ''
};
